import React from 'react'

const SkipButton = ({ name = 'onboarding', onSkip, className = '' }) => {
  const handleSkip = () => {
    const key = `skip_${name}`
    const expireKey = `skip_${name}_expire`

    const expireDate = new Date()
    expireDate.setDate(expireDate.getDate() + 30)

    localStorage.setItem(key, 'true')
    localStorage.setItem(expireKey, expireDate.toISOString())

    // Tell parent to close modal
    if (onSkip) onSkip()
  }

  return (
    <button
      onClick={handleSkip}
      className={`absolute top-4 right-4 text-sm text-[#6b4c7c] hover:underline ${className}`}
    >
      Skip
    </button>
  )
}

export default SkipButton